import React, { useEffect, useState } from 'react'
import TextField from '@mui/material/TextField';
import FormControlLabel from '@mui/material/FormControlLabel';
import Switch, { SwitchProps } from '@mui/material/Switch';
import { styled } from '@mui/material/styles';
import Input from '@mui/material/Input';
import InputLabel from '@mui/material/InputLabel';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import InputAdornment from '@mui/material/InputAdornment';
import IconButton from '@mui/material/IconButton';
import FormControl from '@mui/material/FormControl';

import { SaveDealerData, UpdateDealerData } from './ActionCreator';
import Loader from '../../../../presentationals/Loader/Loader.component'
import Popup from '../../../../presentationals/Popup/Popup.component'
export default function Add({ editData, handleEditingData }) {
    const [loader, setLoader] = useState(false)
    const [popup, setPopup] = useState({ show: false, popupStatus: "" })
    const [showPassword, setShowPassword] = useState(false)
    const [objectData, setObjectData] = useState({
        name: "",
        emailId: "",
        mobileNo: "",
        active: false,
        password: "",
        shareUrl: "",
        licenseId: "",
    })

    const inputField = [
        { label: "Name", value: objectData?.name, type: "text", name: "name" },
        { label: "Email Id", value: objectData?.emailId, type: "email", name: "emailId" },
        { label: "Mobile No", value: objectData?.mobileNo, type: "number", name: "mobileNo" },
        { label: "Password", value: objectData?.password, type: "password", name: "password" },
        { label: "Share URl", value: objectData?.shareUrl, type: "text", name: "shareUrl" },
        { label: "License Id", value: objectData?.licenseId, type: "text", name: "licenseId" },
    ]

    useEffect(() => {
        if (editData?.id) {
            setObjectData({
                name: editData?.name || "",
                emailId: editData?.emailId || "",
                mobileNo: editData?.mobileNo || "",
                active: editData?.active || false,
                mobileVerified: editData?.mobileVerified || false,
                password: editData?.password || "",
                shareUrl: editData?.shareUrl || "",
                licenseId: editData?.licenseId || "",
            })
        } else {
            setObjectData({
                name: "",
                emailId: "",
                mobileNo: "",
                active: false,
                password: "",
                shareUrl: "",
                licenseId: "",
            })
        }
    }, [])


    const handlechange = (e, type) => {
        const { value } = e.target;
        setObjectData((prev) => ({
            ...prev,
            [type]: value
        }))
    }

    const handleSave = () => {
        let obj = { ...objectData }
        if (editData?.id) {
            obj.id = editData?.id;
            setLoader(true)
            UpdateDealerData(obj, callback => {
                setLoader(false)
                console.log("cal", callback)
                if (callback?.message == "success" && callback?.status == 200) {
                     setPopup({ show: true, popupStatus: "Dealer Updated Successfully" })

                } else {
                   setPopup({ show: true, popupStatus: "Error Updating Dealer" })

                }
                removePopup()
            })
            handleEditingData({})

        } else {
            setLoader(true)
            SaveDealerData(obj, callback => {
                setLoader(false)
                console.log("cal", callback)
                if (callback?.message == "success" && callback?.status == 200) {
                    setPopup({ show: true, popupStatus: "Dealer Added Successfully" })

                } else {
                    setPopup({ show: true, popupStatus: "Error Adding Dealer" })

                }
                removePopup()
            })
        }
        setObjectData({
            name: "",
            emailId: "",
            mobileNo: "",
            active: false,
            password: "",
            shareUrl: "",
            licenseId: "",
        })
    }

    const closePopup = () => {
        setPopup({ show: false, popupStatus: "" })
    }

    const removePopup = () => {
        setTimeout(() => {
            closePopup()
        }, 5000)
    }


    return (
        <>
            {
                loader ? <Loader /> : ""
            }
            {
                popup?.show ? <Popup popupStatus={popup?.popupStatus} closePopup={closePopup} /> : ""
            }
            <div style={{ padding: '0 20px', marginTop: '40px' }}>
                <div style={{ borderRadius: '8px', boxShadow: '0 4px 8px 0 rgba(0,0,0,.2)', margin: '5px auto', padding: '20px 15px' }}>
                    <div className="row">
                        {
                            inputField ? inputField?.map((value, id) => {
                                if (value?.name == "password") return null
                                return (
                                    <div className="col-sm-4 col-xs-12" key={id}>
                                        <TextField sx={{ margin: '15px 0' }} fullWidth id="standard-basic" label={value?.label} variant="standard" value={value?.value} type={value?.type} onChange={(e) => handlechange(e, value?.name)} />
                                    </div>
                                )
                            })
                                : ''}
                        <div className="col-sm-4 col-xs-12" style={{ marginTop: '15px' }}>
                            <FormControl sx={{ width: '100%' }} variant="standard">
                                <InputLabel htmlFor="standard-adornment-password">Password</InputLabel>
                                <Input
                                    id="standard-adornment-password"
                                    type={showPassword ? 'text' : 'password'}
                                    onChange={(e) => handlechange(e, "password")}
                                    value={objectData?.password}
                                    endAdornment={
                                        <InputAdornment position="end">
                                            <IconButton
                                                aria-label={
                                                    showPassword ? 'hide the password' : 'display the password'
                                                }
                                                onClick={() => setShowPassword((prev) => !prev)}
                                                onMouseDown={(e) => e.preventDefault()}
                                                onMouseUp={(e) => e.preventDefault()}
                                            >
                                                {showPassword ? <VisibilityOff /> : <Visibility />}
                                            </IconButton>
                                        </InputAdornment>
                                    }
                                />
                            </FormControl>
                        </div>

                    </div>
                    <div className="row">
                        <div className="col-sm-1 col-xs-12" style={{ marginTop: '15px' }}>
                            <FormControlLabel
                                control={<IOSSwitch sx={{ m: 1 }} />}
                                label="Active"
                                checked={objectData?.active}
                                onChange={(event) => setObjectData((prev) => ({
                                    ...prev,
                                    "active": event.target.checked
                                }))}
                            />
                        </div>
                        {
                            editData?.id ?
                                <div className="col-sm-2 col-xs-12" style={{ marginTop: '15px' }}>
                                    <FormControlLabel
                                        control={<IOSSwitch sx={{ m: 1 }} />}
                                        label="Mobile Verified"
                                        checked={objectData?.mobileVerified}
                                        onChange={(event) => setObjectData((prev) => ({
                                            ...prev,
                                            "mobileVerified": event.target.checked
                                        }))}
                                    />
                                </div>
                                : ''}
                    </div>

                    <div style={{ textAlign: 'center', margin: '10px 0' }}>
                        <button className="btn btn-primary" onClick={() => handleSave()}>Save</button>
                    </div>
                </div>
            </div>
        </>
    )
}




const IOSSwitch = styled((props: SwitchProps) => (
    <Switch focusVisibleClassName=".Mui-focusVisible" disableRipple {...props} />
))(({ theme }) => ({
    width: 42,
    height: 26,
    padding: 0,
    '& .MuiSwitch-switchBase': {
        padding: 0,
        margin: 2,
        transitionDuration: '300ms',
        '&.Mui-checked': {
            transform: 'translateX(16px)',
            color: '#fff',
            '& + .MuiSwitch-track': {
                backgroundColor: '#65C466',
                opacity: 1,
                border: 0,
                ...theme.applyStyles('dark', {
                    backgroundColor: '#2ECA45',
                }),
            },
            '&.Mui-disabled + .MuiSwitch-track': {
                opacity: 0.5,
            },
        },
        '&.Mui-focusVisible .MuiSwitch-thumb': {
            color: '#33cf4d',
            border: '6px solid #fff',
        },
        '&.Mui-disabled .MuiSwitch-thumb': {
            color: theme.palette.grey[100],
            ...theme.applyStyles('dark', {
                color: theme.palette.grey[600],
            }),
        },
        '&.Mui-disabled + .MuiSwitch-track': {
            opacity: 0.7,
            ...theme.applyStyles('dark', {
                opacity: 0.3,
            }),
        },
    },
    '& .MuiSwitch-thumb': {
        boxSizing: 'border-box',
        width: 22,
        height: 22,
    },
    '& .MuiSwitch-input': {
        margin: '0'
    },
    '& .MuiSwitch-track': {
        borderRadius: 26 / 2,
        backgroundColor: '#E9E9EA',
        opacity: 1,
        transition: theme.transitions.create(['background-color'], {
            duration: 500,
        }),
        ...theme.applyStyles('dark', {
            backgroundColor: '#39393D',
        }),
    },
}));